(() => {
  'use strict';
  const controllers = new WeakMap();
  window.RZMounts = window.RZMounts || {};
  window.RZMounts.stand = function mount(root) {
    if (controllers.has(root)) return;
    const abort = new AbortController(), signal = abort.signal;
    const listen = (node, type, fn, options = {}) => node?.addEventListener(type, fn, {...options, signal});
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    const form = root.querySelector('.ic-form');
    const main = root.querySelector('#rz-gallery-main');
    const thumbs = root.querySelector('#rz-gallery-thumbs');
    const slides = [...(main?.querySelectorAll(':scope > [data-rz-slide]') || [])];
    const thumbItems = [...(thumbs?.querySelectorAll('.ic-thumb') || [])];
    const bar = root.querySelector('#rz-sticky');
    const tilt = root.querySelector('#rz-tilt');
    const cmp = root.querySelector('#rz-cmp-carousel');
    const cmpWrap = root.querySelector('#rz-cmp-nudge');
    const notice = form?.querySelector('.rz-product-error');
    const reviews = root.querySelector('#rz-vr-carousel');
    const reviewItems = [...(reviews?.querySelectorAll('.ic-vr') || [])];
    let reviewFrame = 0, reviewDrag = null, reviewObserver;
    let selected = form?.querySelector('input[name=id]')?.value;
    let selectedOption = root.querySelector('[data-rz-variant-id]:checked')?.dataset.rzOptionValueId;
    let pending = false, adding = false, failed = false, active = 0, sequence = 0;
    let requestAbort, stickyObserver, comparisonObserver, resizeObserver, effectsObserver;
    const visibleSections = new Set();
    let measureSticky = false;
    let frame = 0, galleryFrame = 0, etaTimer = 0, timeout = 0, destroyed = false;
    let swiped = false, cmpInView = false, drag = null, mainWidth = 0;
    const purchaseControls = () => [...root.querySelectorAll('#rz-atc,[data-rz-add],[data-rz-sticky-add]')];
    const savedDisabled = new Map();
    const motion = () => reduce.matches ? 'instant' : 'smooth';
    function reviewState(item, playing) {
      item.dataset.playing = String(playing);
      const cover = item.querySelector('.vr-cover');
      if (cover) {cover.inert = playing; cover.setAttribute('aria-hidden', String(playing));}
    }
    function reviewSync() {
      reviewFrame = 0;
      if (!reviews || !nearViewport(reviews)) return;
      const bounds = reviews.getBoundingClientRect();
      reviewItems.forEach(item => {
        const rect = item.getBoundingClientRect();
        const visible = rect.right > bounds.left + 1 && rect.left < bounds.right - 1;
        item.inert = !visible; item.setAttribute('aria-hidden', String(!visible));
        if (!visible) item.querySelector('video')?.pause();
      });
    }
    function reviewMove(step) {
      if (!reviews || !reviewItems.length) return;
      const stride = reviewItems[0].getBoundingClientRect().width + 24;
      reviews.scrollTo({left: Math.max(0, Math.round(reviews.scrollLeft / stride) + step) * stride, behavior: motion()});
    }
    async function playReview(button) {
      const item = button.closest('.ic-vr'), video = item?.querySelector('video');
      if (!video || button.getAttribute('aria-busy') === 'true') return;
      let error = item.querySelector('.rz-video-error');
      if (error) error.hidden = true;
      button.setAttribute('aria-busy', 'true');
      root.querySelectorAll('video').forEach(other => {if (other !== video) other.pause();});
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      video.controls = true; video.tabIndex = 0;
      try {
        await video.play();
        if (!destroyed && !video.paused) {reviewState(item, true); video.focus({preventScroll:true});}
      } catch (failure) {
        if (destroyed) return;
        reviewState(item, false);
        if (failure.name !== 'AbortError') {
          if (!error) {error = document.createElement('p'); error.className='rz-video-error';error.setAttribute('role','alert');item.firstElementChild.append(error);}
          error.textContent = 'This video could not play. Please try again.'; error.hidden = false;
        }
      } finally {button.removeAttribute('aria-busy');}
    }
    function message(text = '') { if (notice) { notice.textContent = text; notice.hidden = !text; } }
    function lock(value) {
      for (const button of purchaseControls()) {
        if (value) {
          if (!savedDisabled.has(button)) savedDisabled.set(button, button.disabled);
          button.disabled = true;
        } else if (savedDisabled.has(button)) {
          button.disabled = savedDisabled.get(button); savedDisabled.delete(button);
        }
      }
    }
    function syncThumbs(scroll = false, warm = true) {
      thumbItems.forEach((item, index) => {
        const on = Number(item.dataset.i) === active;
        if (item.dataset.active !== String(on)) item.dataset.active = String(on);
        const button = item.querySelector('button');
        if (button?.getAttribute('aria-pressed') !== String(on)) button?.setAttribute('aria-pressed', String(on));
        if (on && scroll && thumbs) {
          const a = item.getBoundingClientRect(), b = thumbs.getBoundingClientRect();
          if (a.left < b.left || a.right > b.right) thumbs.scrollTo({left: item.offsetLeft - thumbs.firstElementChild.offsetLeft, behavior: motion()});
        }
      });
      slides.forEach((slide, index) => {
        // Fetch only the current photo and its neighbours; hidden carousel images compete with the hero.
        if (index === active || (warm && Math.abs(index - active) <= 1)) slide.querySelectorAll('template[data-rz-gallery-image]').forEach(template => {
          const content = template.content.cloneNode(true);
          content.querySelectorAll('img').forEach(image => {image.loading = 'eager'; image.decoding = 'async';});
          template.replaceWith(content);
        });
        if (slide.inert !== (index !== active)) slide.inert = index !== active;
        if (slide.getAttribute('aria-hidden') !== String(index !== active)) slide.setAttribute('aria-hidden', String(index !== active));
        if (index === active) slide.querySelectorAll('video[data-rz-gallery-poster]').forEach(video => {video.poster = video.dataset.rzGalleryPoster; delete video.dataset.rzGalleryPoster;});
        if (index !== active) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      if (main && main.dataset.activeIndex !== String(active)) main.dataset.activeIndex = String(active);
    }
    function go(index, animate = true, warm = true) {
      if (!main || !slides.length) return;
      active = Math.max(0, Math.min(slides.length - 1, index));
      main.scrollTo({left: active * (mainWidth || main.clientWidth), behavior: animate ? motion() : 'instant'});
      syncThumbs(true, warm);
    }
    function variantImage(input, warm = true) {
      const index = input?.dataset.gallerySlide !== undefined ? Number(input.dataset.gallerySlide) : slides.findIndex(slide => slide.dataset.mediaId === input?.dataset.variantImage);
      // Keep the already-visible photo in place without a redundant initial scroll/layout.
      if (index >= 0 && index !== active) go(index, false, warm);
    }
    function stickyState(shown) {
      if (!bar) return;
      if (bar.dataset.state === (shown ? 'shown' : 'hidden') && bar.inert === !shown) return;
      if (!shown && bar.contains(document.activeElement)) form?.querySelector('#rz-atc')?.focus({preventScroll: true});
      bar.dataset.state = shown ? 'shown' : 'hidden';
      bar.inert = !shown;
      bar.setAttribute('aria-hidden', String(!shown));
    }
    function bindSticky() {
      stickyObserver?.disconnect();
      const atc = root.querySelector('#rz-atc');
      if (!bar || !atc) return;
      stickyState(atc.getBoundingClientRect().bottom <= 0);
      if (!window.IntersectionObserver) return;
      stickyObserver = new IntersectionObserver(entries => {
        const entry = entries[entries.length - 1];
        stickyState(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, {threshold: 0});
      stickyObserver.observe(atc);
    }
    function restoreSelection() {
      root.querySelectorAll('[data-rz-variant-id]').forEach(input => input.checked = input.dataset.rzVariantId === selected);
      const select = root.querySelector('#rz-sticky-pack');
      if (select && selectedOption) select.value = selectedOption;
    }
    async function selectVariant(input, updateHistory = true) {
      if (!input || adding) { restoreSelection(); return; }
      const variant = input.dataset.rzVariantId;
      if (variant === selected && !pending && !failed) { restoreSelection(); return; }
      const version = ++sequence;
      requestAbort?.abort(); requestAbort = new AbortController();
      clearTimeout(timeout);
      pending = true; failed = false; message(); lock(true); form?.setAttribute('aria-busy', 'true');
      const url = new URL(root.dataset.productUrl || location.pathname, location.origin);
      url.searchParams.set('variant', variant); url.searchParams.set('section_id', 'rz-product-state-stand');
      const requestSignal = requestAbort.signal;
      timeout = setTimeout(() => { if (version === sequence) requestAbort.abort(); }, 15000);
      try {
        const response = await fetch(url, {credentials: 'same-origin', signal: requestSignal});
        if (!response.ok) throw new Error('This pack could not be loaded. Please select it again.');
        const html = await response.text();
        if (version !== sequence || destroyed) return;
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rz-component="stand"]');
        if (!next || next.querySelector('input[name=id]')?.value !== variant) throw new Error('This pack could not be confirmed. Please select it again.');
        const replacements = [...root.querySelectorAll('[data-rz-product-update]')].map(old => {
          const name = old.dataset.rzProductUpdate;
          const fresh = next.querySelector(`[data-rz-product-update="${CSS.escape(name)}"]`);
          if (!fresh) throw new Error('This pack could not be loaded. Please select it again.');
          return {old, fresh};
        });
        const focusId = root.contains(document.activeElement) ? document.activeElement.id : '';
        replacements.forEach(({old, fresh}) => {
          const select = old.querySelector('#rz-sticky-pack'), nextSelect = fresh.querySelector('#rz-sticky-pack');
          if (select && nextSelect) {
            for (const option of [...select.options]) {
              const nextOption = [...nextSelect.options].find(item => item.value === option.value);
              if (nextOption) {option.textContent = nextOption.textContent; option.disabled = nextOption.disabled;}
              else option.remove();
            }
            for (const option of [...nextSelect.options]) if (![...select.options].some(item => item.value === option.value)) select.append(option.cloneNode(true));
          } else old.replaceWith(fresh);
        });
        selected = variant; selectedOption = input.dataset.rzOptionValueId;
        form.querySelector('input[name=id]').value = variant;
        pending = false; lock(false); savedDisabled.clear(); restoreSelection();
        if (updateHistory) {
          const current = new URL(location.href); current.searchParams.set('variant', variant);
          history.replaceState(history.state, '', current);
        }
        variantImage(input); bindSticky(); eta();
        if (focusId && document.activeElement.id !== focusId) root.querySelector('#' + CSS.escape(focusId))?.focus({preventScroll: true});
        root.dispatchEvent(new CustomEvent('rz:variant-updated', {bubbles: true, detail: {variantId: variant}}));
      } catch (error) {
        if (version !== sequence || destroyed) return;
        pending = false; failed = true; restoreSelection(); lock(false);
        message(error.name === 'AbortError' ? 'This pack took too long to load. Please select it again.' : error.message);
      } finally {
        if (version === sequence) { clearTimeout(timeout); form?.removeAttribute('aria-busy'); }
      }
    }
    async function add(variant, button) {
      if (pending || adding || button?.disabled) return;
      if (failed && button?.id === 'rz-atc') { message('Please select a pack again before adding it.'); return; }
      if (!window.RZCart) { message('The cart could not load. Please refresh this page.'); return; }
      adding = true; message(); lock(true);
      const selectors = [...root.querySelectorAll('[data-rz-variant-id],#rz-sticky-pack')];
      const disabled = selectors.map(el => el.disabled); selectors.forEach(el => el.disabled = true);
      try {
        const result = await window.RZCart.addToCart(Number(variant), {button});
        if (result && !result.success) message(result.error || 'Please review the message in your cart before trying again.');
      } catch (error) { message(error.message || 'The cart request was interrupted. Review your cart before trying again.'); }
      finally { adding = false; selectors.forEach((el, i) => el.disabled = disabled[i]); lock(false); }
    }
    function compareProgress() {
      if (!cmp || !nearViewport(cmp)) return;
      const length = cmp.children.length || 1, max = cmp.scrollWidth - cmp.clientWidth;
      const progress = max > 0 ? Math.max(0, Math.min(1, cmp.scrollLeft / max)) : 0;
      const fill = root.querySelector('#rz-cmp-fill');
      if (fill) fill.style.width = ((1 / length + progress * (1 - 1 / length)) * 100).toFixed(2) + '%';
    }
    function nudge() { if (cmpWrap) cmpWrap.dataset.nudge = swiped ? 'done' : cmpInView && !reduce.matches ? 'on' : 'off'; }
    function stopNudge() { swiped = true; nudge(); }
    function nearViewport(element) {
      const section = element.closest('section');
      if (!section) return true;
      if (effectsObserver) return visibleSections.has(section);
      const rect = section.getBoundingClientRect();
      return rect.bottom >= -300 && rect.top <= innerHeight + 300;
    }
    function scrollEffects() {
      frame = 0;
      const nums = [...root.querySelectorAll('.ic-step')].filter(nearViewport);
      const visibleQuotes = [...root.querySelectorAll('.ic-quote')].filter(nearViewport);
      if (!nums.length && !visibleQuotes.length && !measureSticky) return;
      const middle = innerHeight / 2;
      let best = 0, distance = Infinity;
      nums.forEach((el, i) => { const r = el.getBoundingClientRect(), d = Math.abs(r.top + r.height / 2 - middle); if (r.height && d < distance) {distance = d; best = i;} });
      const states = nums.map((element, i) => [element, 'pulse', i === best ? 'on' : 'off']);
      visibleQuotes.forEach(element => {
        const rect = element.getBoundingClientRect();
        states.push([element, 'focus', !fine.matches && rect.height && rect.top <= middle && rect.bottom >= middle ? 'on' : 'off']);
      });
      const showSticky = measureSticky ? root.querySelector('#rz-atc')?.getBoundingClientRect().bottom <= 0 : null;
      measureSticky = false;
      states.forEach(([element, key, value]) => {if (element.dataset[key] !== value) element.dataset[key] = value;});
      if (showSticky !== null) stickyState(showSticky);
    }
    function scheduleEffects(event) {
      if (event?.type === 'scroll' || event?.type === 'resize') measureSticky = true;
      if (!frame) frame = requestAnimationFrame(scrollEffects);
    }
    function eta() {
      clearTimeout(etaTimer);
      if (destroyed || document.hidden) return;
      const arr = root.querySelector('[data-eta="arrival"]');
      if (!arr) return;
      try {
        const fmt = new Intl.DateTimeFormat('en-US', {timeZone: 'America/Denver', year: 'numeric', month: 'numeric', day: 'numeric'});
        const now = new Date(), parts = Object.fromEntries(fmt.formatToParts(now).map(p => [p.type, p.value]));
        const date = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day + 2));
        arr.textContent = 'Arrives by ' + new Intl.DateTimeFormat('en-US', {timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric'}).format(date);
        const today = fmt.format(now); let low = +now, high = low + 27 * 3600000;
        while (high - low > 1000) {const mid = Math.floor((low + high) / 2); if (fmt.format(mid) === today) low = mid; else high = mid;}
        etaTimer = setTimeout(eta, high - +now + 1000);
      } catch {}
    }
    function resetTilt() { if (tilt) {tilt.style.setProperty('--rx', '0deg'); tilt.style.setProperty('--ry', '0deg'); tilt.removeAttribute('data-tilting');} }
    listen(root, 'submit', e => {if (e.target === form) {e.preventDefault(); add(selected, e.submitter || form.querySelector('#rz-atc'));}});
    listen(root, 'change', e => {
      if (e.target.matches('[data-rz-variant-id]')) selectVariant(e.target);
      if (e.target.id === 'rz-sticky-pack') {
        const input = root.querySelector('#rz-pack-' + CSS.escape(e.target.value));
        if (input) {input.checked = true; selectVariant(input);}
      }
    });
    listen(root, 'click', e => {
      const button = e.target.closest('button,a[data-rz-scroll-to]');
      if (!button) return;
      if (button.hasAttribute('data-rz-add')) add(button.dataset.rzAdd, button);
      if (button.hasAttribute('data-rz-review-play')) playReview(button);
      if (button.hasAttribute('data-rz-sticky-add')) { e.preventDefault(); add(selected, root.querySelector('#rz-atc')); }
      if (button.dataset.rzGalleryTarget) {
        const step = Number(button.dataset.rzGalleryStep);
        if (button.dataset.rzGalleryTarget === 'main') go(active + step);
        else if (button.dataset.rzGalleryTarget === 'reviews') reviewMove(step);
        else thumbs?.scrollBy({left: step * thumbs.clientWidth * .8, behavior: motion()});
      }
      const thumb = button.closest('.ic-thumb'); if (thumb) go(Number(thumb.dataset.i));
      if (button.dataset.rzScrollTo) {
        const target = button.dataset.rzScrollTo === '#rz-hero'
          ? root.querySelector('form[data-rz-product-url]')
          : root.querySelector(button.dataset.rzScrollTo);
        if (target) {
          e.preventDefault();
          // Resolve every preceding section's true height before calculating an anchor destination.
          root.dataset.rzRevealSections = 'true';
          const focusTarget = target.querySelector('h1,h2,h3') || target;
          if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({preventScroll: true});
          if (button.dataset.rzScrollTo === '#rz-hero') target.style.scrollMarginTop = `${(document.querySelector('[data-rz-header-sticky]')?.getBoundingClientRect().height || 0) + 16}px`;
          target.scrollIntoView({behavior: reduce.matches ? 'instant' : 'smooth', block: 'start'});
        }
      }
    });
    listen(main, 'scroll', () => {
      if (galleryFrame) return;
      galleryFrame = requestAnimationFrame(() => {galleryFrame = 0; if (!main.clientWidth) return; active = Math.max(0, Math.min(slides.length - 1, Math.round(main.scrollLeft / main.clientWidth))); syncThumbs(true);});
    }, {passive: true});
    listen(main, 'keydown', e => {
      if (e.target !== main) return;
      const to = {ArrowRight: active + 1, ArrowLeft: active - 1, Home: 0, End: slides.length - 1}[e.key];
      if (to !== undefined) {e.preventDefault(); go(to);}
    });
    listen(main, 'pointerdown', e => {
      if (!fine.matches || e.pointerType === 'touch' || e.button !== 0 || e.target.closest('video,button,a')) return;
      drag = {id: e.pointerId, x: e.clientX, left: main.scrollLeft}; main.dataset.dragging = 'true'; main.setPointerCapture?.(e.pointerId); e.preventDefault();
    });
    listen(main, 'pointermove', e => {if (drag?.id === e.pointerId) main.scrollLeft = drag.left + drag.x - e.clientX;});
    function endDrag(e) {if (drag?.id !== e.pointerId) return; main.releasePointerCapture?.(e.pointerId); drag = null; delete main.dataset.dragging; go(Math.round(main.scrollLeft / main.clientWidth));}
    listen(main, 'pointerup', endDrag); listen(main, 'pointercancel', endDrag);
    listen(reviews, 'scroll', () => {if (!reviewFrame) reviewFrame = requestAnimationFrame(reviewSync);}, {passive:true});
    listen(reviews, 'keydown', e => {
      if (e.target !== reviews) return;
      const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (step) {e.preventDefault();reviewMove(step);}
    });
    listen(reviews, 'pointerdown', e => {
      if (!fine.matches || e.pointerType === 'touch' || e.button !== 0 || e.target.closest('video,button,a')) return;
      reviewDrag = {id:e.pointerId,x:e.clientX,left:reviews.scrollLeft};reviews.dataset.dragging='true';reviews.setPointerCapture?.(e.pointerId);e.preventDefault();
    });
    listen(reviews, 'pointermove', e => {if (reviewDrag?.id===e.pointerId) reviews.scrollLeft=reviewDrag.left+reviewDrag.x-e.clientX;});
    const endReviewDrag = e => {if (reviewDrag?.id===e.pointerId){reviews.releasePointerCapture?.(e.pointerId);reviewDrag=null;delete reviews.dataset.dragging;reviewSync();}};
    listen(reviews,'pointerup',endReviewDrag);listen(reviews,'pointercancel',endReviewDrag);
    root.querySelectorAll('video').forEach(video => {
      listen(video,'play',()=>{
        root.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();});
        const item=video.closest('.ic-vr');if(item)reviewState(item,true);
      });
      const stopped=()=>{const item=video.closest('.ic-vr');if(item)reviewState(item,false);};
      listen(video,'pause',stopped);listen(video,'ended',stopped);
    });
    listen(cmp, 'scroll', compareProgress, {passive: true}); listen(cmp, 'pointerdown', stopNudge, {passive: true});
    listen(cmp, 'keydown', e => {const dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (dir) {e.preventDefault(); stopNudge(); cmp.scrollBy({left: dir * (cmp.firstElementChild.getBoundingClientRect().width + 12), behavior: motion()});}});
    const quote = root.querySelector('.ic-snip');
    listen(quote, 'keydown', e => {if (e.key === ' ' || e.key === 'Enter') {e.preventDefault(); quote.toggleAttribute('data-paused');}});
    listen(quote, 'click', () => quote.toggleAttribute('data-paused'));
    listen(tilt, 'pointermove', e => {
      if (!fine.matches || reduce.matches || drag) return;
      const r = tilt.getBoundingClientRect(); if (!r.width || !r.height) return;
      const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      tilt.style.setProperty('--ry', ((x - .5) * 10).toFixed(2) + 'deg'); tilt.style.setProperty('--rx', ((.5 - y) * 8).toFixed(2) + 'deg');
      tilt.style.setProperty('--mx', (x * 100).toFixed(1) + '%'); tilt.style.setProperty('--my', (y * 100).toFixed(1) + '%'); tilt.dataset.tilting = 'true';
    });
    listen(tilt, 'pointerleave', resetTilt);
    listen(window, 'scroll', scheduleEffects, {passive: true});
    listen(window, 'resize', event => {scheduleEffects(event); compareProgress(); reviewSync();});
    listen(reduce, 'change', () => {resetTilt(); nudge();}); listen(fine, 'change', resetTilt);
    listen(document, 'visibilitychange', () => {eta(); if (document.hidden) root.querySelectorAll('video').forEach(v => v.pause());});
    listen(window, 'pageshow', e => {if (e.persisted) {eta(); bindSticky();}});
    listen(window, 'popstate', () => {const id = new URL(location.href).searchParams.get('variant'); const input = root.querySelector(`[data-rz-variant-id="${CSS.escape(id || '')}"]`); if (input) {input.checked = true; selectVariant(input, false);}});
    if (window.IntersectionObserver) {
      effectsObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) visibleSections.add(entry.target);
          else visibleSections.delete(entry.target);
        });
        scheduleEffects();
      }, {rootMargin: '300px 0px'});
      new Set([...root.querySelectorAll('.ic-step,.ic-quote,#rz-cmp-carousel,#rz-vr-carousel')].map(element => element.closest('section')).filter(Boolean)).forEach(section => effectsObserver.observe(section));
      reviewObserver = new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting)entry.target.pause();});},{threshold:0});
      reviewItems.forEach(item=>reviewObserver.observe(item.querySelector('video')));
      if (cmpWrap) {comparisonObserver = new IntersectionObserver(entries => {cmpInView = entries[entries.length - 1].isIntersecting; if (cmpInView) compareProgress(); nudge();}, {threshold: .6}); comparisonObserver.observe(cmpWrap);}
    }
    if (window.ResizeObserver && main) {
      resizeObserver = new ResizeObserver(entries => {
        const width = Math.round(entries[entries.length - 1].contentRect.width);
        if (!width || width === mainWidth) return;
        const previousWidth = mainWidth;
        mainWidth = width;
        if (previousWidth) go(active, false, false);
      });
      resizeObserver.observe(main);
    }
    tilt?.setAttribute('data-ready', '1');
    syncThumbs(false, false); variantImage(root.querySelector('[data-rz-variant-id]:checked'), false); bindSticky(); eta(); scheduleEffects();
    root.dataset.rzReady = 'true';
    root.querySelector('[data-rz-purchase-controls]')?.removeAttribute('disabled');
    root.querySelectorAll('[data-rz-add]').forEach(button => { button.disabled = false; });
    root.querySelector('[data-rz-script-notice]')?.setAttribute('hidden','');
    controllers.set(root, () => {
      destroyed = true; abort.abort(); requestAbort?.abort();
      stickyObserver?.disconnect(); comparisonObserver?.disconnect(); resizeObserver?.disconnect(); effectsObserver?.disconnect(); visibleSections.clear();
      reviewObserver?.disconnect();cancelAnimationFrame(reviewFrame);
      cancelAnimationFrame(frame); cancelAnimationFrame(galleryFrame); clearTimeout(etaTimer); clearTimeout(timeout);
      root.querySelectorAll('video').forEach(v => v.pause()); controllers.delete(root);
    });
  };
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-rz-component="stand"]').forEach(root => controllers.get(root)?.()));
})();
